export default __webpack_public_path__ + "static/media/Version (1) - Early Prop_11.f51b6506.jpg";